import { RootState } from 'store/rootReducer';

export const analyticsSlice = (state: RootState) => state.features.analytics;

export const gtagEvents = (state: RootState) => analyticsSlice(state).gtagEvents;
